import React from 'react'
import Modal from '@/components/ui/Modal'
import { ReactComponent as HistoryIcon } from '@/assets/icons/history.svg'
import Typography from '@/components/ui/Typography'

import classes from './HistoryModal.module.scss'
import { RouteHistoryList } from '@/components/RouteHistoryList'

export type HistoryModalProps = {
  projectId: number
  routeId: number
  onClose: () => void
}

const HistoryModal = ({ projectId, routeId, onClose }: HistoryModalProps) => {
  return (
    <Modal onClose={onClose} isOpen>
      <Modal.Header>
        <div>
          <Modal.Icon>
            <HistoryIcon />
          </Modal.Icon>

          <Typography variant={'xl'} className={classes.title}>
            History
          </Typography>
        </div>
        <div>
          <Modal.Close onClick={onClose} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <div className={classes.content}>
          <RouteHistoryList projectId={projectId} routeId={routeId} />
        </div>
      </Modal.Content>
    </Modal>
  )
}

export default HistoryModal
